<template>
  <div>
    <AppPageHeader title="User" />
    <router-view v-if="currentUser" :key="$route.fullPath" />
  </div>
</template>

<script lang="ts" setup> 
import { useHead } from '@unhead/vue'
import AppPageHeader from '@/components/app/AppPageHeader.vue'
import { useAuth } from '@/composables/useAuth'
import { useRoute } from 'vue-router'

useHead({
  title: 'User'
})

const $route = useRoute()
const { currentUser } = useAuth()
</script>
